import { createAccessControlProvider } from '@/components/composed/AccessControlProvider'
import { APP_ACCESS_CONTROL_LIST } from './constants'
import type { TAppAccessControlContext, TAppAccessControlList } from './types'

export const { AccessControlProvider: AppAccessControlProvider, useAccessControl: useAppAccessControl } = createAccessControlProvider<
  TAppAccessControlList,
  TAppAccessControlContext
>(APP_ACCESS_CONTROL_LIST)
